import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

import Utils from 'src/app/utils';

import timezones from 'timezones-list';

declare var require: any;

@Component({
  selector: 'app-worker-edit',
  templateUrl: './worker-edit.component.html',
  styleUrls: ['./worker-edit.component.scss']
})
export class WorkerEditComponent implements OnInit {

  tab:any = "info";

  worker: any;
  id?: number;
  groups: any;
  check_in_times: { value: number; name: string }[] = [];
  alert_times = Utils.getAlertTimes();

  formGroup = new FormGroup({
    name: new FormControl('',[Validators.required]),
    email: new FormControl('',[Validators.email]),
    phone: new FormControl('',[]),
    cell: new FormControl('',[]),
    country: new FormControl(null,[]),
    timezone: new FormControl(null,[]),
    check_in_freq: new FormControl('',[Validators.required,]),
    call_alert: new FormControl('',[]),
    sms_alert: new FormControl('',[]),
    monitors: new FormControl('',[Validators.required]),
    groups: new FormControl([],[]),
    vehicle_id: new FormControl(null,[]),
    // worker_groups: new FormControl('',[]),
  })

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  countryListArray  = Utils.getCountries();
  timezoneListArray = timezones;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) {

    this.check_in_times = Utils.getCheckinTimes(this.okService.settings?.id);

    let host_path=window.location.href;
    let queryString = host_path.substring(host_path.indexOf("tab"));
    let urlParams = new URLSearchParams(queryString);
    if(urlParams.get('tab')){
      this.tab = urlParams.get('tab');
    }


  }


  ngOnInit(): void {

    this.id = +this.route.snapshot.params['id'];

    this.getWorker();
  }
  
  ngAfterViewInit()	: void {
    Utils.setupPopover();
  }

  getWorker(){

    this.okService.get("workers/"+this.id,{expand: "app_settings,permissions,device_info,checkin_process,vehicle,arc,status"})
    .subscribe((data) => {

      this.worker = data.body;

      if (this.tab === 'permissions' && !this.showPermissionsTab()) {
        this.tab = 'info';
      }

      this.setForm();

    });
  }

  setForm(){
    this.formGroup.setValue({
      name: this.worker.name,
      phone: this.worker.phone,
      cell: this.worker.cell,
      email: this.worker.email,
      country: this.worker.country,
      timezone: this.worker.timezone,
      check_in_freq: this.worker.check_in_freq,
      call_alert: this.worker.call_alert,
      sms_alert: this.worker.sms_alert,
      monitors: this.worker.monitors,
      groups: this.worker.group_ids,
      vehicle_id: this.worker.vehicle_id,
    });
  }

  submitForm(){
    this.submitted = true;
    if (
      this.formGroup.valid
      ) {
        let values = this.formGroup.value
        //console.log(values);

        this.okService.put("workers/"+this.id,values)
        .subscribe((data) => {

          this.worker = data.body;

          //console.log("worker",this.worker);
          //console.log("monitors",this.worker.monitors);
          //console.log("vehicle",this.worker.vehicle_id);
          this.setForm();

          this.okService.setAlert(this.transloco.translate("The worker has been updated"),"success");

        });

      }

    return false;
  }

  showPermissionsTab(): boolean {
    const platform = this.worker?.permissions?.platform;
    return platform === 'ios' || platform === 'android';
  }

  doDelete(){
    if(confirm(this.transloco.translate("Are you sure you want to delete ")+this.worker.name)) {

        this.okService.delete('workers/'+this.worker.id)
        .subscribe((data) => {

          this.okService.setAlert(this.transloco.translate("We have deleted this worker for you"),"success");

          this.router.navigateByUrl('/mgmt/workers/workers');


        }
        );
    }
  }


  doActivate(){
    this.okService.post('workers/activate/'+this.worker.id,[])
    .subscribe((data) => {

      console.log('data',data);

      this.okService.setAlert(this.transloco.translate("We have deactived this worker for you"),"success");

      this.router.navigateByUrl('/mgmt/workers/workers');

    });
  }
  
}
